module.exports = __webpack_public_path__ + "img/info-circle.0cdaa6fd.svg";